import styled from 'styled-components';
import { theme, toRem } from 'design';
import { Icon } from '../Icon';
import { Text } from '../Typography';

export const AuthContainer = styled.div`
  position: relative;
  flex-flow: column nowrap;
  flex-grow: 1;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  min-height: 100%;
  padding: ${toRem(theme.spacing.large)} 0;

  @media (min-width: ${theme.breakpoint.small}px) {
    justify-content: space-between;
  }
`;

export const AuthInviteContainer = styled(AuthContainer)`
  height: auto;

  @media (min-width: ${theme.breakpoint.small}px) {
    min-height: 100vh;
  }
`;

export const AuthContent = styled.section`
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;

  @media (min-width: ${theme.breakpoint.small}px) {
    flex-grow: 1;
  }

  &.email-verify {
    @media (min-width: ${theme.breakpoint.med}px) and (max-width: ${theme.breakpoint.large}px) {
      width: unset;

      header > button {
        left: 0;
      }
    }
  }
`;

export const AuthContentInner = styled.div`
  position: relative;
  align-self: center;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${toRem(33)};
  justify-items: center;
  width: 100%;
  max-width: ${toRem(382)};
`;

export const AuthContentLayout = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${toRem(27.5)};
  flex-grow: 1;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: ${toRem(300)};
`;

export const AuthFieldset = styled.fieldset`
  margin-bottom: ${toRem(33)};
`;

export const AuthColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${toRem(theme.spacing.xsmall)};
  width: 100%;
`;

export const AuthConsentGroup = styled.fieldset`
  margin-bottom: ${toRem(22)};
`;

export const AuthLegalText = styled(Text).attrs({
  size: 'small',
})`
  line-height: 125%;
  text-align: center;
  color: ${theme.color.neutral[700]};
`;

export const AuthButtonGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${toRem(theme.spacing.xsmall)};
  justify-items: center;
  width: 100%;
  max-width: ${toRem(300)};
`;

export const AuthSSOInputLayout = styled.div`
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

export const AuthSSOEmailIcon = styled(Icon)`
  width: ${toRem(15)};
  height: ${toRem(15)};
  margin-right: ${toRem(11)};
`;

export const AuthOrContainer = styled.div.attrs({
  'aria-hidden': true,
})`
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.medium};
  font-size: ${toRem(13.25)};
  line-height: 100%;
  color: ${theme.color.neutral[700]};

  &::before {
    content: '';
    position: absolute;
    left: 0;
    width: 40%;
    border-bottom: ${toRem(1)} solid ${theme.color.neutral[200]};
  }

  &::after {
    content: '';
    position: absolute;
    right: 0;
    width: 40%;
    border-bottom: ${toRem(1)} solid ${theme.color.neutral[200]};
  }
`;

export const AuthInviteButtonWrap = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`;
